import * as Swiper from 'swiper';

window.Globals = {
  ...Swiper,
}
